export const sanitizeParams = (
  paramValues: Record<string, any>
): Record<string, any> => {
  const paramCopy: Record<string, any> = { ...paramValues };
  Object.keys(paramCopy).forEach(
    (key) =>
      (paramCopy[key] === undefined || paramCopy[key] === null) &&
      delete paramCopy[key]
  );
  return paramCopy;
};
